/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStatisticsResponse } from '../../models/get-statistics-response';

export interface GachaServiceGetStatistics$Params {
}

export function gachaServiceGetStatistics(http: HttpClient, rootUrl: string, params?: GachaServiceGetStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStatisticsResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetStatistics.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStatisticsResponse>;
    })
  );
}

gachaServiceGetStatistics.PATH = '/api/v3/gateway/statistics';
